import { offersAssistantSeats } from './assistantSeats'
import { useBillingPlan } from './useBillingPlan'

export interface AssistantSeatsOffer {
  offered: boolean
  isLoading: boolean
}

export const useAssistantSeatsOffered = (): AssistantSeatsOffer => {
  const { customer, plan, isFetching } = useBillingPlan()

  return { offered: offersAssistantSeats(customer, plan), isLoading: isFetching }
}
